import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-19554
// Обновленные коммуникации оверквотников
export const overquotaNewCommunication: boolean = getFeature('overquota-new-communication') || false;
